import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Megaphone, Eye, AlertTriangle, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PageHeader, Empty } from "@/components/common";
import { AnnouncementDialog } from "@/components/AnnouncementForm";
import { useAuth } from "@/context/AuthContext";
import { api, fmtDateTime } from "@/lib/api";
import { can } from "@/lib/perm";
import { cn } from "@/lib/utils";

export default function Comunicazioni() {
  const { user } = useAuth();
  const isAdmin = can(user, "publish_announcements");
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/announcements").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  return (
    <div data-testid="announcements-page">
      <PageHeader title="Comunicazioni" subtitle="Avvisi e comunicazioni aziendali."
        actions={isAdmin && <Button onClick={() => setOpen(true)} data-testid="new-announcement-button"><Plus className="mr-1.5 h-4 w-4" />Nuova comunicazione</Button>} />
      {items.length === 0 ? (
        <Empty icon={Megaphone} text="Nessuna comunicazione pubblicata." testId="announcements-empty" />
      ) : (
        <div className="space-y-3">
          {items.map((a, i) => (
            <Link key={a.id} to={`/comunicazioni/${a.id}`} style={{ animationDelay: `${i * 40}ms` }}
              className={cn("lift fade-up flex gap-4 rounded-lg border bg-card p-5", !a.read && "border-l-4 border-l-primary")}
              data-testid={`announcement-card-${a.id}`}>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  {a.priority === "high" && <span className="inline-flex items-center gap-1 rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700 dark:bg-red-500/15 dark:text-red-300"><AlertTriangle className="h-3 w-3" />Importante</span>}
                  {a.recipient_ids && <span className="inline-flex items-center gap-1 rounded-full bg-muted px-2 py-0.5 text-xs"><Users className="h-3 w-3" />Mirata</span>}
                  {!a.read && <span className="text-xs font-semibold text-primary">Nuova</span>}
                </div>
                <h3 className="mt-1.5 text-base font-semibold">{a.title}</h3>
                <p className="mt-1 line-clamp-2 text-sm text-muted-foreground">{a.body}</p>
                <p className="mt-3 text-xs text-muted-foreground">{a.author_name} · {fmtDateTime(a.created_at)}</p>
              </div>
              {isAdmin && (
                <div className="flex shrink-0 items-start gap-1.5 text-xs text-muted-foreground" data-testid={`announcement-reads-${a.id}`}>
                  <Eye className="h-3.5 w-3.5" />{a.read_count}/{a.recipient_count}
                </div>
              )}
            </Link>
          ))}
        </div>
      )}
      {open && <AnnouncementDialog open={open} onOpenChange={setOpen} onSaved={load} />}
    </div>
  );
}
